<template>
  <v-layout>
    <v-flex
      v-for="(option, index) in options"
      :key="index"
      class="app-checkbox"
      pt-0
      pb-0
      mt-0
      mb-0
    >
      <v-checkbox
        v-model="state"
        :label="option[onText]"
        :value="option[onValue]"
        :color="color"
        :row="row"
        :error="hasError"
        :disabled="option['disabled'] || disabled"
        @change="change"
      />
      <v-tooltip
        v-if="hasTooltip && option.tooltip.show"
        top
      >
        <v-icon
          slot="activator"
          :color="option.tooltip.color"
          small
        >
          {{ option.tooltip.type }}
        </v-icon>
        <span>{{ option.tooltip.text }}</span>
      </v-tooltip>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'AppCheckBox',
  props: {
    value: {
      type: [Boolean, String, Number, Array],
      default: () => null
    },
    options: {
      type: Array,
      default: () => []
    },
    onText: {
      type: String,
      default: () => 'title'
    },
    onValue: {
      type: String,
      default: () => 'value'
    },
    color: {
      type: String,
      default: () => 'secondary'
    },
    row: {
      type: Boolean,
      default: () => false
    },
    v: {
      type: Object,
      default: () => ({})
    },
    hasTooltip: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },
  data: () => ({
    state: []
  }),
  watch: {
    value: {
      handler: 'sync',
      immediate: true
    }
  },
  computed: {
    hasError() {
      return this.v
        ? (this.v.$invalid && this.v.$dirty) || this.forceError
        : false
    }
  },
  methods: {
    change(value) {
      this.$emit('input', value)
    },
    sync() {
      this.state = this.value
    }
  }
}
</script>

<style lang="stylus" scoped>
  .app-checkbox
    display: flex
    justify-content: center
    align-items: center
</style>
